import Spinner from '../../components/Spinner';
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const TIPO_COLORS = {
  AV:    { color: '#2563eb', label: 'AV' },
  AD:    { color: '#ea580c', label: 'Convencional' },
  MIXTA: { color: '#16a34a', label: 'Mixta' },
};

function MapaHabilitacionesInner({ lineas, filtro }) {
  const map = useMap();
  React.useEffect(() => {
    if (!lineas || lineas.length === 0) return;
    const layers = [];
    const bounds = [];
    const paleta = ['#2563eb','#dc2626','#16a34a','#9333ea','#ea580c','#0891b2'];
    const coloresPorTipo = { AV: '#2563eb', AD: '#ea580c', MIXTA: '#16a34a' };
    const BASE_DEPS = "https://services7.arcgis.com/XTupIrLX53AjaJqO/arcgis/rest/services/Dependencias_Adif_p%C3%BAblico/FeatureServer/0/query";
    const BASE_TRAMOS = "https://services7.arcgis.com/XTupIrLX53AjaJqO/arcgis/rest/services/Red_Ferroviaria_de_Inter%C3%A9s_General___Adif__RFIG_CM_vista_2/FeatureServer/43/query";

    const cargar = async () => {
      for (let i = 0; i < lineas.length; i++) {
        const h = lineas[i];
        if (!h.lat_inicio || !h.lat_fin) continue;
        const color = filtro === 'todas' ? (coloresPorTipo[h.tipo_red] || '#2563eb') : paleta[i % paleta.length];

        try {
          // Buscar coords inicio y fin
          let latI = h.lat_inicio, lonI = h.lon_inicio;
          let latF = h.lat_fin, lonF = h.lon_fin;

          // Obtener geometría real de la línea
          const codNum = (h.cod_linea || '').split('-')[0].trim().replace(/\s+/g, '').substring(0,3);
          const filtroLinea = `COD_LINEA LIKE '${codNum}%'`;
          const r = await fetch(`${BASE_TRAMOS}?f=geojson&where=${encodeURIComponent(filtroLinea)}&outFields=COD_LINEA,CODTRAMO,PKI,PKD&resultRecordCount=500`);
          const data = await r.json();

          if (data.features && data.features.length > 0) {
            const distFn = (a, b) => Math.sqrt((a[0]-b[0])**2 + (a[1]-b[1])**2);
            let segments = data.features.filter(f => f.geometry).map(f => f.geometry.coordinates.map(c => [c[1], c[0]]));
            let ordered = [segments[0]];
            let remaining = segments.slice(1);
            while (remaining.length > 0) {
              const last = ordered[ordered.length-1];
              const lastPt = last[last.length-1];
              let bestIdx = 0, bestDist = Infinity, bestRev = false;
              remaining.forEach((seg, i) => {
                const d1 = distFn(lastPt, seg[0]);
                const d2 = distFn(lastPt, seg[seg.length-1]);
                if (d1 < bestDist) { bestDist = d1; bestIdx = i; bestRev = false; }
                if (d2 < bestDist) { bestDist = d2; bestIdx = i; bestRev = true; }
              });
              const next = remaining[bestIdx];
              ordered.push(bestRev ? [...next].reverse() : next);
              remaining.splice(bestIdx, 1);
            }
            let allPts = ordered.flat();
            const idxI = allPts.reduce((best, p, i) => distFn(p, [latI, lonI]) < distFn(allPts[best], [latI, lonI]) ? i : best, 0);
            const idxF = allPts.reduce((best, p, i) => distFn(p, [latF, lonF]) < distFn(allPts[best], [latF, lonF]) ? i : best, 0);
            const desde = Math.min(idxI, idxF);
            const hasta = Math.max(idxI, idxF);
            const puntosIntermedios = allPts.slice(desde, hasta + 1);

            if (puntosIntermedios.length > 1) {
              const linea = L.polyline(puntosIntermedios, { color, weight: 4, opacity: 0.9 }).addTo(map);
              linea.bindPopup(`<strong>${h.nombre_linea || h.cod_linea}</strong>`);
              layers.push(linea);
              puntosIntermedios.forEach(p => bounds.push(p));
            }
          } else {
            // Fallback: línea recta
            const puntos = [[latI, lonI], [latF, lonF]];
            const linea = L.polyline(puntos, { color, weight: 4, opacity: 0.9 }).addTo(map);
            layers.push(linea);
            bounds.push(...puntos);
          }

          // Marcadores inicio y fin
          [[latI, lonI], [latF, lonF]].forEach(pt => {
            const m = L.circleMarker(pt, { radius: 7, fillColor: color, color: 'white', weight: 2, fillOpacity: 1 }).addTo(map);
            layers.push(m);
          });
        } catch(e) {
          // Fallback línea recta
          const puntos = [[h.lat_inicio, h.lon_inicio], [h.lat_fin, h.lon_fin]];
          const linea = L.polyline(puntos, { color, weight: 4, opacity: 0.9 }).addTo(map);
          layers.push(linea);
          bounds.push(...puntos);
        }
      }
      if (bounds.length > 0) map.fitBounds(bounds, { padding: [30, 30] });
    };

    cargar();
    return () => layers.forEach(l => { try { map.removeLayer(l); } catch {} });
  }, [map, lineas, filtro]);
  return null;
}

export default function Habilitaciones() {
  const [tab, setTab] = useState('material');
  const [data, setData] = useState({ material: [], lineas: [] });
  const [filtro, setFiltro] = useState('todas');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/maquinistas/yo/habilitaciones')
      .then(r => setData(r.data))
      .finally(() => setLoading(false));
  }, []);

  const lineasFiltradas = data.lineas.filter(l => filtro === 'todas' || l.tipo_red === filtro);

  if (loading) return <Spinner />;

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 16px' }}>Mis habilitaciones</h2>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['material', '🚂 Material'], ['lineas', '🛤️ Líneas'], ['mapa', '🗺️ Mapa']].map(([val, label]) => (
          <button key={val} onClick={() => setTab(val)} style={{
            flex: 1, padding: '10px', borderRadius: 10, border: 'none', cursor: 'pointer',
            fontSize: 12, fontWeight: 500,
            background: tab === val ? '#1a1a1a' : '#fff',
            color: tab === val ? '#fff' : '#555'
          }}>{label}</button>
        ))}
      </div>

      {tab === 'material' && (
        <div>
          {data.material.length === 0 ? (
            <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#aaa' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🚂</div>
              <div>Sin habilitaciones de material</div>
            </div>
          ) : data.material.map(h => (
            <div key={h.id} style={{ background: '#fff', borderRadius: 12, padding: 14, marginBottom: 8, border: '1px solid #e5e5e5' }}>
              <div style={{ fontWeight: 600, fontSize: 15 }}>🚂 {h.modelo}</div>
              {h.fecha_desde && <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Desde: {h.fecha_desde}</div>}
              {h.fecha_hasta && <div style={{ fontSize: 12, color: '#888' }}>Hasta: {h.fecha_hasta}</div>}
            </div>
          ))}
        </div>
      )}

      {tab === 'lineas' && (
        <div>
          {data.lineas.length === 0 ? (
            <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#aaa' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🛤️</div>
              <div>Sin habilitaciones de línea</div>
            </div>
          ) : data.lineas.map(h => {
            const tipo = TIPO_COLORS[h.tipo_red] || TIPO_COLORS.AD;
            return (
              <div key={h.id} style={{ background: '#fff', borderRadius: 12, padding: 14, marginBottom: 8, border: '1px solid #e5e5e5' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{h.nombre_linea || h.cod_linea}</div>
                  <span style={{ fontSize: 10, background: tipo.color + '20', color: tipo.color, borderRadius: 6, padding: '2px 6px', fontWeight: 600 }}>
                    {tipo.label}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: '#555', marginTop: 4 }}>{h.estacion_inicio} → {h.estacion_fin}</div>
                {h.fecha_desde && <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>Desde: {h.fecha_desde}</div>}
              </div>
            );
          })}
        </div>
      )}

      {tab === 'mapa' && (
        <div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
            {[['todas','Todas'],['AV','AV'],['AD','Conv.'],['MIXTA','Mixta']].map(([val, label]) => (
              <button key={val} onClick={() => setFiltro(val)} style={{
                padding: '5px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 500,
                background: filtro === val ? '#1a1a1a' : '#f0f0f0',
                color: filtro === val ? '#fff' : '#555'
              }}>{label}</button>
            ))}
          </div>
          <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e5e5', height: 400 }}>
            <MapContainer center={[40.4, -3.7]} zoom={6} style={{ height: '100%', width: '100%' }}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="© OpenStreetMap" />
              <MapaHabilitacionesInner lineas={lineasFiltradas} filtro={filtro} />
            </MapContainer>
          </div>
          <div style={{ display: 'flex', gap: 12, marginTop: 10, flexWrap: 'wrap' }}>
            {Object.entries(TIPO_COLORS).map(([key, val]) => (
              <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11 }}>
                <div style={{ width: 20, height: 3, background: val.color, borderRadius: 2 }} />
                <span style={{ color: '#555' }}>{val.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
